module.exports = __webpack_public_path__ + "static/media/business-energy-achievement-awards-img.6329886d.png";